import { gsap } from 'gsap/all'
import { router } from '../../src/js/core/router.js'
import lottie from 'lottie-web'
import { dl } from '../../src/js/core/app.js'

const navLinks = Array.from(document.querySelectorAll('header nav li, .js-nav-fullscreen li, .js-nav-mobile li'))

export class Header {
  constructor () {
    this.header = document.querySelector('.js-header')
    this.navToggle = document.querySelector('.js-nav-toggle')
    this.navFullScreen = document.querySelector('.js-nav-fullscreen')
    this.navMobile = document.querySelector('.js-nav-mobile')
    this.layers = [...document.querySelectorAll('.js-layer')]
    this.insert = document.querySelector('.js-insert-line')
    this.subMenus = [...document.querySelectorAll('.js-submenu')]
    this.headerNavLinks = [...document.querySelectorAll('header nav li')]
    this.mobileNavMain = document.querySelector('.js-nav-mobile-main')
    this.mobileNavSubmenu = document.querySelector('.js-nav-mobile-submenu')
    this.treshold = 2
    this.navOpen = false
    this.isScrolled = false
    this.isRouting = false
    this.isTweening = false
    this.mobileSubmenuIsOpen = false

    this.dropdownActive = false
    this.dropdownEntered = false

    this.init()
  }

  bindResize = () => {
    window.addEventListener('resize', this.handleResize)
    setTimeout(() => {
      this.handleResize()
    }, 500)
  }

  handleResize = () => {
    this.resizeSubmenus()
  }

  resizeSubmenus = () => {
    this.subMenus.forEach((submenu) => {
      const headerNavLink = this.headerNavLinks[submenu.dataset.index - 1] ? this.headerNavLinks[submenu.dataset.index - 1].children[0] : false
      if (headerNavLink) {
        const center = headerNavLink.getBoundingClientRect().width / 2
        const left = headerNavLink.getBoundingClientRect().left
        const markerPosition = center + left
        const markerArrow = submenu.querySelector('.js-header-marker-arrow')
        markerArrow.style.transform = `translate(calc(${markerPosition}px - 50%), -100%)`
      }
    })
  }

  bindDropDownMenus = () => {
    if (this.headerNavLinks.length <= 0) {
      return false
    }
    this.headerNavLinks.forEach((item, index) => {
      item.addEventListener('mouseenter', (e) => {
        this.showDropdown(index)
      })
    })

    this.subMenus.forEach(menu => {
      menu.addEventListener('mouseleave', (e) => {
        this.hideDropdown(menu)
      })
    })
  }

  showDropdown = (index) => {
    this.hideDropdown()
    const subMenu = document.querySelector(`.js-submenu[data-index="${index + 1}"]`)
    if (subMenu) {
      subMenu.classList.add('show')
      this.activeSubmenu = subMenu
    }
  }

  hideDropdown(el = this.activeSubmenu) {
    if (el) {
      el.classList.remove('show')
    }
  }

  open () {
    if (this.navOpen || this.isTweening) { return false }

    const curHeaderWidth = this.header.getBoundingClientRect().width

    this.navOpen = true
    document.body.style.overflow = 'hidden'

    const lineOffset = this.header.getBoundingClientRect().width - curHeaderWidth
    this.line.style.marginLeft = `${lineOffset}px`

    const nav = window.innerWidth < 1000 ? this.navMobile : this.navFullScreen
    this.tweenNavToggle('open')
    this.tweenNav(nav, 'open')
    dl.toggleMenu('open')
  }

  close () {
    if (!this.navOpen || this.isTweening) { return false }

    document.body.style.overflow = 'unset'
    document.body.style.overflowX = 'hidden'

    this.line.style.marginLeft = ''

    this.navOpen = false

    const nav = window.innerWidth < 1000 ? this.navMobile : this.navFullScreen
    this.tweenNavToggle('close')
    this.tweenNav(nav, 'close')

    if (window.innerWidth < 1000) {
      this.resetClicks()
    } else {
      Array.from(this.navFullScreen.querySelectorAll('.sub-menu')).forEach(menu => {
        menu.style.display = 'none'
      })
    }

    Array.from(nav.querySelectorAll('a')).forEach(a => {
      a.removeAttribute('style')
    })

    dl.toggleMenu('close')
  }

  tweenNavToggle (mode) {
    this.navToggle.classList.toggle('is-open')
  }

  tweenNav (nav, mode) {
    if (nav === this.navFullScreen) {
      this.tweenLayers(mode)
    }

    const x = nav === this.navMobile && mode === 'close' ? '100%' : 0

    gsap.to(nav, 0, {
      opacity: mode === 'open' ? 1 : 0,
      delay: mode === 'open' ? 0 : 0.75,
      onComplete: () => {
        nav.style.pointerEvents = mode === 'open' ? 'all' : 'none'
      }
    })

    gsap.to(nav, 0, {
      delay: 0,
      onStart: () => {
        nav.style.overflowY = mode === 'open' ? 'scroll' : 'hidden'
      },
    })

    if (window.innerWidth >= 1000) {
      gsap.to(nav, 0.5, {
        ease: 'power4.out',
        onStart: () => {
          this.isTweening = true
        },
        onComplete: () => {
          setTimeout(() => { this.isTweening = false }, 500)
        }
      })
    } else {
      gsap.to(nav, 0.5, {
        x,
        ease: 'power4.out',
        onStart: () => {
          this.isTweening = true
        },
        onComplete: () => {
          this.isTweening = false
        }
      })
    }

    this.tweenChildren(nav, mode)
  }

  tweenChildren (nav, mode) {
    const children = nav === this.navFullScreen ? [...nav.querySelectorAll('.menu-fullscreen__col > ul > li, .language-switch')] : [...nav.querySelectorAll('nav .nav-mobile__mainmenu > ul > li')]

    gsap.to(children, 0.5, {
      opacity: mode === 'open' ? 1 : 0,
      y: mode === 'open' ? 0 : -40,
      stagger: mode === 'open' ? 0.05 : 0,
      delay: mode === 'open' ? 0.125 : 0,
      ease: 'expo.out',
      onComplete: () => {
        if (mode === 'close') {
          gsap.set(children, { y: 40 })
        }
      }
    })
  }

  tweenLayers (mode) {
    gsap.to(this.layers, 0.5, {
      scaleY: mode === 'open' ? 1 : 0,
      delay: mode === 'open' ? 0.125 : 0,
      ease: 'power4.out'
    })

    if (window.scrollY < this.treshold) {
      if (mode === 'open') {
        this.header.classList.add('is-scrolled')
      } else {
        setTimeout(() => {
          this.header.classList.remove('is-scrolled')
        }, 250)
      }
    }
  }

  bindToggle () {
    this.navToggle.addEventListener('click', () => {
      if (this.navOpen) {
        this.close()
      } else {
        this.open()
      }
    })

    this.navToggle.addEventListener('mouseenter', () => {
      gsap.to(this.navToggle, 0.5, {
        scale: 1.05,
        ease: 'expo.out'
      })
    })

    this.navToggle.addEventListener('mouseleave', () => {
      gsap.to(this.navToggle, 0.5, {
        scale: 1,
        ease: 'expo.out'
      })
    })
  }

  checkScroll = (event, initial = false) => {
    if (this.isRouting) { return false }

    if (window.scrollY > this.treshold && !this.isScrolled) {
      this.isScrolled = true
      this.tweenHeaderBar()
    } else if (window.scrollY <= this.treshold && this.isScrolled) {
      this.isScrolled = false
      this.tweenHeaderBar()
    }

    if (!initial && !this.navOpen && window.innerWidth > 1000) {
      const difference = Math.abs(window.scrollY - this.storedY)
      if (window.scrollY > this.storedY && window.scrollY > this.treshold && difference < 100) {
        this.translate('up')
      } else if (window.scrollY < this.storedY) {
        this.translate('down')
      }

      this.storedY = window.scrollY
    }
  }

  translate (mode) {
    const y = mode === 'up' ? '-100%' : 0

    this.hideDropdown()

    gsap.to(this.header, 0.5, {
      y,
      ease: 'power4.out'
    })
  }

  tweenHeaderBar () {
    if (this.isScrolled) {
      this.header.classList.add('is-scrolled')
    } else {
      this.header.classList.remove('is-scrolled')
    }
  }

  bindScroll () {
    window.addEventListener('scroll', this.checkScroll)
  }

  route () {
    // router.on('NAVIGATE_OUT', ({ from, trigger, location }) => {
    //   this.isRouting = true

    //   this.hideDropdown()

    //   setTimeout(() => {
    //     this.close()
    //   }, 250)

    //   if (trigger !== 'popstate') {
    //     if (trigger.closest('.js-nav-fullscreen')) {
    //       this.insertScribble(trigger)

    //       const allTriggers = [...document.querySelectorAll('.header__nav a')]
    //       const findTrigger = allTriggers.find(fullTrigger => { return fullTrigger.textContent === trigger.textContent })

    //       if (findTrigger) {
    //         this.activeLink = findTrigger
    //         this.showLine(findTrigger)
    //       }
    //     }

    //     if (trigger.closest('.header__nav')) {
    //       this.activeLink = trigger
    //       this.showLine(trigger)

    //       const allTriggers = [...document.querySelectorAll('.js-nav-fullscreen a')]
    //       const findTrigger = allTriggers.find(fullTrigger => { return fullTrigger.textContent === trigger.textContent })

    //       if (findTrigger) {
    //         this.insertScribble(findTrigger)
    //       }
    //     }
    //   }
    // })

    this.insertLine()

    if (document.querySelector('.js-nav-fullscreen .current-menu-item')) {
      this.insertScribble(document.querySelector('.js-nav-fullscreen .current-menu-item a'))
    }

    if (document.querySelector('.header__nav .current-menu-item')) {
      setTimeout(() => {
        this.activeLink = document.querySelector('.header__nav .current-menu-item a')
        this.showLine(document.querySelector('.header__nav .current-menu-item a'))
      }, 250)
    }

    // router.on('NAVIGATE_IN', ({ to, location }) => {
    //   navLinks.forEach(navLink => {
    //     navLink.classList.remove('current-menu-item')
    //     if (navLink.querySelector('a').href === location.href) {
    //       navLink.classList.add('current-menu-item')
    //     }
    //   })

    //   if (!document.querySelector('.header__nav .current-menu-item')) {
    //     this.activeLink = false
    //     this.disappearLine()
    //   }

    //   this.translate('down')
    // })

    // router.on('NAVIGATE_END', () => {
    //   this.replaceSelect()

    //   setTimeout(() => {
    //     this.isRouting = false
    //     this.checkScroll(false, true)
    //   }, 500)
    // })

    window.addEventListener('resize', () => {
      if (this.activeLink) {
        const linkBounds = this.activeLink.getBoundingClientRect()
        this.line.style.width = `${linkBounds.width}px`

        gsap.set(this.line, {
          x: linkBounds.left,
        })
      }
    })
  }

  replaceSelect () {
    let headerSelects = [...document.querySelectorAll('.js-header-select select')]
    let footerSelect = document.querySelector('.js-footer-select select')
    let fakeSelect = document.querySelector('.js-footerfake-select select')

    headerSelects.forEach(headerSelect => {
      headerSelect.outerHTML = fakeSelect.outerHTML
    })

    let headerSelectNews = [...document.querySelectorAll('.js-header-select select')]

    headerSelectNews.forEach(headerSelectNew => {
      headerSelectNew.addEventListener('change', e => {
        let value = headerSelectNew.options[headerSelectNew.selectedIndex].value
        window.location = value
      })
    })
  }

  insertScribble (trigger) {
    if (this.scribble) {
      const animation = this.scribble
      animation.setDirection(-1)
      animation.setSpeed(2)
      animation.play()

      animation.onComplete = () => {
        animation.wrapper.querySelector('svg').remove()
      }
    }

    this.drawScribble(trigger)
  }

  drawScribble (trigger) {
    const scribbles = ['1', '3', '5', '24', '25']
    const random = Math.floor(Math.random() * scribbles.length)

    this.scribble = lottie.loadAnimation({
      container: trigger,
      renderer: 'svg',
      direction: 1,
      loop: false,
      autoplay: false,
      path: `/wp-content/themes/justdiggit2021/lotties/${scribbles[random]}.json`
    })

    this.scribble.play()
  }

  insertLine () {
    this.line = document.createElement('div')
    this.lineIsHidden = true
    this.activeLink = false
    this.line.style.position = 'absolute'
    this.line.style.top = '0'
    this.line.style.left = '0'
    this.line.style.opacity = '0'
    this.line.style.width = '0'
    this.line.style.height = '4px'
    this.line.style.pointerEvents = 'none'
    this.line.style.backgroundColor = '#fff'
    this.line.style.zIndex = 100;
    this.header.appendChild(this.line)
  }

  showLine (navLink) {
    if (this.lineIsHidden) {
      gsap.to(this.line, {
        duration: 0.3,
        opacity: 1,
        delay: 0.5,
        ease: 'power2.out'
      })

      this.lineIsHidden = false
    }

    this.moveLine(navLink)
  }

  moveLine (navLink) {
    if (navLink) {
      const linkBounds = navLink.getBoundingClientRect()
      // this.line.style.width = `${linkBounds.width}px`

      gsap.to(this.line, {
        duration: 0.6,
        x: linkBounds.left,
        width: `${linkBounds.width}px`,
        ease: 'expo.out'
      })
    }
  }

  disappearLine () {
    gsap.to(this.line, {
      duration: 0.3,
      opacity: 0,
      ease: 'power2.out',
      onComplete: () => {
        this.line.style.width = '0'
      }
    })

    this.lineIsHidden = true
  }

  bindChildren () {
    if (!this.navFullScreen) {
      return false
    }

    const children = [...this.navFullScreen.querySelectorAll('.menu-fullscreen__col > ul > li')]
    const grandChildren = [...this.navFullScreen.querySelectorAll('.menu-fullscreen__col > ul > li > ul > li')]

    this.setHovers(children, 'child')
    this.setHovers(grandChildren, 'grand')
    this.setClicks()
  }

  setHovers (children, mode) {
    children.forEach(child => {
      child.addEventListener('mouseenter', () => {
        children.forEach((child, index) => {
          child.querySelector('a').style.color = mode === 'child' ? '#fff' : '#052827'

          if (child.querySelector('.sub-menu')) {
            child.querySelector('.sub-menu').style.display = 'none'
          }
        })

        child.querySelector('a').style.color = mode === 'child' ? '#052827' : '#FF7700'

        if (child.querySelector('.sub-menu')) {
          child.querySelector('.sub-menu').style.display = 'flex'
        }
      })

      if (mode === 'child') {
        if (child.querySelector('.sub-menu')) {
          const transform = child.getBoundingClientRect().top - child.closest('ul').querySelector('li').getBoundingClientRect().top
          child.querySelector('.sub-menu').style.transform = `translateY(-${transform}px)`
        }
      }
    })
  }

  setClicks () {
    const children = [...document.querySelectorAll('.js-nav-mobile-main > ul > li')]
    this.closeMobileNavSubmenu()

    children.forEach((child, index) => {
      child.addEventListener('click', (e) => {
        if (!e.target.href) {
          this.showMobileNavSubmenu(index, child.querySelector('a').innerHTML)
        }
      })
    })
  }

  showMobileNavSubmenu = (index, title) => {
    const subMenu = document.querySelector(`.nav-mobile__submenu[data-index="${index + 1}"]`)
    if (subMenu) {
      subMenu.style.display = 'block'
      subMenu.querySelector('.js-nav-mobile-submenu-title').innerHTML = title

      gsap.to(this.mobileNavMain, {
        xPercent: '-=100',
        ease: 'power4.out',
        duration: 0.5,
      })

      gsap.to(this.mobileNavSubmenu, {
        xPercent: '-=100',
        ease: 'power4.out',
        duration: 0.5,
      })
    }
  }

  closeMobileNavSubmenu = () => {
    const allCloseSubmenuArrows = [...document.querySelectorAll('.js-nav-mobile-submenu-close')]

    allCloseSubmenuArrows.forEach(close => {
      close.addEventListener('click', () => {
        gsap.to(this.mobileNavMain, {
          xPercent: '+=100',
          ease: 'power4.out',
          duration: 0.5,
        })

        gsap.to(this.mobileNavSubmenu, {
          xPercent: '+=100',
          ease: 'power4.out',
          duration: 0.5,
          onComplete: () => {
            document.querySelectorAll(`.nav-mobile__submenu`).forEach(subMenu => {
              subMenu.style.display = ''
            })
          }
        })
      })
    })
  }

  resetClicks () {
    const children = [...this.navMobile.querySelectorAll('ul > li.menu-item-has-children')]

    children.forEach(child => {
      child.classList.remove('is-open')
    })
  }

  bindDLLangSwitch () {
    this.langSwitches = [...document.querySelectorAll('.language_switch')]

    this.langSwitches.forEach(lang => {
      lang.addEventListener('change', () => {
        dl.langSwitch(lang.querySelector(':checked').getAttribute('data-lang'))
      })
    })
  }

  init () {
    this.bindResize()
    this.bindScroll()
    this.bindToggle()
    this.bindDropDownMenus()
    setTimeout(() => { this.bindChildren() }, 200)
    this.checkScroll(false, true)
    this.route()
    this.bindDLLangSwitch()
  }
}
